import React from 'react';

import Button from '@atlaskit/button';
import { openMapUsersDialog } from 'src/services/mappedUsers';

const MapUsersButton = (props) => {
  return (
    <Button onClick={openMapUsersDialog} {...props}>
      Link users...
    </Button>
  );
};

export default MapUsersButton;
